<template>
  <a-space>
    <a-button
      v-if="showPayment"
      type="primary"
      @click="confirmPayment('paid')"
    >
      已回款
    </a-button>
    <a-button
      v-if="showPayment"
      type="primary"
      @click="confirmPayment('unpaid')"
    >
      未回款
    </a-button>
    <a-button
      v-if="showInvoice"
      type="primary"
      @click="confirmInvoice('invoiced')"
    >
      已开票
    </a-button>
    <a-button
      v-if="showInvoice"
      type="primary"
      @click="confirmInvoice('not_invoiced')"
    >
      未开票
    </a-button>
  </a-space>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import {
  batchOrderSummaryFinancePayment,
  batchOrderSummaryFinanceInvoice
} from '@/api/order_summary'

const paymentTitles = {
  paid: '确定已回款吗?',
  unpaid: '确定未回款吗?'
}

const invoiceTitles = {
  invoiced: '确定已开票吗?',
  not_invoiced: '确定未开票吗?'
}

export default {
  name: 'FinanceOrdersBatchStatus',
  props: {
    selectedRowKeys: {
      type: Array,
      required: true
    }
  },
  computed: {
    showPayment() {
      return hasPermission('order_summary/finance_orders/payment')
    },
    showInvoice() {
      return hasPermission('order_summary/finance_orders/invoice')
    }
  },
  methods: {
    warningSelectObjects() {
      this.$warning({
        title: '请选择操作对象',
        content: ''
      })
    },

    confirmPayment(paymentStatus) {
      const vm = this
      const ids = vm.selectedRowKeys
      if (ids.length === 0) {
        this.warningSelectObjects()
        return
      }
      this.$confirm({
        title: paymentTitles[paymentStatus],
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return batchOrderSummaryFinancePayment({
            ids,
            payment_status: paymentStatus
          }).then((res) => {
            if (res.code === 0) {
              vm.$message.success('操作成功')
              vm.$emit('completed')
            }
          })
        }
      })
    },

    confirmInvoice(invoiceStatus) {
      const vm = this
      const ids = vm.selectedRowKeys
      if (ids.length === 0) {
        this.warningSelectObjects()
        return
      }
      this.$confirm({
        title: invoiceTitles[invoiceStatus],
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return batchOrderSummaryFinanceInvoice({
            ids,
            invoice_status: invoiceStatus
          }).then((res) => {
            if (res.code === 0) {
              vm.$message.success('操作成功')
              vm.$emit('completed')
            }
          })
        }
      })
    }
  }
}
</script>
